<template>
  <Teleport to="body">
    <div v-if="visible" class="cookie">
      <div class="cookie__wrapper">
        <p>
          {{ $t('cookieText') }}
          <a href="/privacy">{{ $t('cookiePrivacy') }}.</a>
        </p>
        <button type="button" @click="accept">OK</button>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    accept() {
      localStorage.setItem('drct-cookie', 'true');
      this.visible = false;
    },
  },
  mounted() {
    if (!localStorage.getItem('drct-cookie')) {
      this.visible = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.cookie {
  display: flex;
  align-items: center;
  background-color: rgb(243, 244, 245);
  position: fixed;
  left: 0;
  box-sizing: border-box;
  font-family: Roboto, sans-serif;
  width: 100%;
  bottom: 0;
  height: 31px;
  // Stay above the public Copilot canvas (z-index: 99999).
  z-index: 100000;

  @media (max-width: 767px) {
    height: auto;
    padding: 8px 8px 10px;
  }

  p {
    margin: 0;
    font-size: 11px;
    color: rgb(27, 39, 51);

    @media (max-width: 767px) {
      font-size: 10px;
      line-height: 14px;
    }
  }

  a {
    font-size: 11px;
    line-height: 1.57;
    color: rgba(42, 138, 234, 0.85);
    border-bottom: 1px solid rgba(42, 138, 234, 0.2);
    text-decoration: none;

    &:hover,
    &:active {
      color: #2a8aea;
      border-bottom: 1px solid rgba(42, 138, 234, 0.4);
    }

    @media (max-width: 767px) {
      font-size: 10px;
    }
  }

  button {
    opacity: 0.85;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.37px;
    color: rgb(42, 138, 234);
    background: none;
    border: none;
    cursor: pointer;
    &:focus-visible {
      outline: 2px solid currentColor;
      outline-offset: 2px;
    }

    @media (max-width: 767px) {
      padding: 10px 20px;
    }

    &:hover,
    &:active {
      opacity: 1;
    }
  }
}

.cookie__wrapper {
  width: 1011px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1010px) {
    width: calc(100% - 64px);
    margin-left: 0;
  }
}
</style>
